import React from 'react';

interface CalendlyWidgetProps {
  url?: string;
}

const CalendlyWidget: React.FC<CalendlyWidgetProps> = ({ 
  url = 'https://calendly.com/quickreachteam/book'
}) => {
  return (
    <div style={{ width: '100%', height: '800px', position: 'relative' }}>
      <iframe
        src={url}
        width="100%"
        height="800"
        frameBorder={0}
        title="Schedule a meeting with QuickReach"
        style={{ 
          border: 0,
          width: '100%',
          height: '800px'
        }}
        allow="payment"
      />
    </div>
  );
};

export default CalendlyWidget;

